import { IErrorResponseType } from "../../constants/commonTypes";
import * as AuthActions from "../actionTypes/authActionTypes";
import { AuthState } from "../reducers/authReducer";


export function ibAuthenticate(request: object): AuthActions.GetIBAuthenticationAction {
  return {
    type: AuthActions.GET_IB_AUTHENTICATION,
    request
  };
}

export function ibAuthenticateRequest(): AuthActions.GetIBAuthenticationRequestAction {
  return {
    type: AuthActions.GET_IB_AUTHENTICATION_REQUEST
  }
}

export function ibAuthenticateSuccess(response: AuthState): AuthActions.GetIBAuthenticationSuccessAction {
  return {
    type: AuthActions.GET_IB_AUTHENTICATION_SUCCESS,
    authResponse: response.authResponse,
    partnerId: response.partnerId,
    partnerName: response.partnerName,
    resumeJourneyEligibility: response.resumeJourneyEligibility,
    originalTxnId: response.originalTxnId,
    customerId: response.customerId
  }
}

export function ibAuthenticateFailure(error: Error | string | IErrorResponseType): AuthActions.GetIBAuthenticationFailureAction {
  return {
    type: AuthActions.GET_IB_AUTHENTICATION_FAILURE,
    error
  }
}

export function ibAuthenticateError() {
  return {
    type: AuthActions.GET_IB_AUTHENTICATION_ERROR,
  }
}
